import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fold",
  "use": "icon-fold-usage",
  "viewBox": "0 0 1228 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1228 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-fold\"><path d=\"M1228.544 306.304a153.6256 153.6256 0 0 0-153.6256-153.9072h-460.032l21.4272 8.7808L481.024 8.96 472.064 0.256H0.9472v863.36c0 85.248 68.6592 154.368 153.2928 154.368h906.4448c16.9472 0 30.72-13.824 30.72-30.8224 0-17.0496-13.7728-30.848-30.72-30.848H154.2144c-50.688 0-91.904-41.4976-91.904-92.672V31.0784l-30.72 30.8224h428.032l-21.4272-8.7552 155.264 152.192 8.9344 8.7552h472.5248a92.1088 92.1088 0 0 1 92.2368 92.2112V849.92c0 17.024 13.7216 30.8224 30.6688 30.8224 16.9728 0 30.72-13.7984 30.72-30.8224V306.304z m-61.3888 172.032l0.2048-61.696H62.4128v61.696h1104.7424z\" p-id=\"3905\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fold.svg
// module id = 5pIo
// module chunks = 36